module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_02.png?f73caa4fc07ee4715d483150129a4ec0";